module.exports = __webpack_public_path__ + "/login_ui/img/au-eb0518ba66d2e3f87766c8ad1d892149.svg";